import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.mjs';
import HseBaseModal from './HseBaseModal.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = HseBaseModal;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOpen)?_c('HseModalOverlay',{ref:"modalOverlay",on:{"click":_vm.onOverlayClick,"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }$event.preventDefault();return _vm.onEscPress($event)}}},[_c('div',{ref:"wrapper",staticClass:"hse-BaseModal",class:_vm.modalClass,style:(_vm.modalStyle),attrs:{"aria-modal":"true","role":"dialog"}},[_c('div',{staticClass:"hse-BaseModal__wrapper",class:_vm.classes.wrapper},[_c('HseIconButton',{staticClass:"hse-BaseModal__closeButton",class:_vm.classes.closeButton,attrs:{"icon":_vm.closeIcon,"variant":"ghost"},on:{"click":_vm.close}}),_vm._v(" "),_vm._t("default")],2)])]):_vm._e()};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
